/**
 * Os níveis a que um risco, um exame ou uma fonte geradora podem ser aplicados, do menos para o
 * mais específico — espelho de `backend/src/types/niveisDeAplicacao.ts`. É a única lista: todo
 * mapa por nível é `Record<NivelDeAplicacao, …>` completo, para que um nível novo quebre a
 * compilação em cada tela que precisa conhecê-lo (#541).
 */
export const NIVEIS_DE_APLICACAO = ['company', 'unit', 'department', 'occupation', 'employee'] as const;

export type NivelDeAplicacao = (typeof NIVEIS_DE_APLICACAO)[number];

export const ROTULO_DO_NIVEL: Record<NivelDeAplicacao, string> = {
  company: 'Empresa',
  unit: 'Unidade',
  department: 'Setor',
  occupation: 'Cargo',
  employee: 'Funcionário',
};
